// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"60396f13","419":"d9bdeeb4","602":"fd65eb7d","945":"50388548","980":"583db3a1"}[chunkId] + ".chunk.js";
};